import { makeStyles } from "@material-ui/core";
import { grey } from "@material-ui/core/colors";

const styles = makeStyles(({ spacing, palette }) => ({
  sortButton: {
    textTransform: "none",
    padding: spacing(0.75, 1.5),
    display: "flex",
    alignItems: "center",
    color: palette.primary.main,
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
  },
  input: {
    borderRadius: 40,
    height: 40,
    flex: 1,
    backgroundColor: grey["100"],
    border: `1px solid ${grey["300"]}`,
  },
}));
export default styles;
